import { DropdownMenu } from '@/components/ui/dropdown-menu';
import { welcomeNavigationTabs } from '@/lib/constants/navigationTabs';
import { ListIcon } from '@phosphor-icons/react';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { Button } from '../ui/button';

export function WelcomeNavbarDropdown() {
  const router = useRouter();
  const [open, setOpen] = useState(false);

  const handleLoginClick = () => {
    setOpen(false);
    router.push('/auth/login');
  };

  return (
    <DropdownMenu
      open={open}
      onOpenChange={setOpen}
      items={welcomeNavigationTabs}
      trigger={
        <div className="px-4 py-3.5 bg-blue-900 rounded-[30px] justify-center items-center gap-2.5 cursor-pointer">
          <ListIcon className="w-6 h-6 text-white" />
        </div>
      }
      footer={
        <div className="border-t border-gray-200 pt-2 mt-2 md:hidden">
          <Button variant="primaryClear" className="w-full" onClick={handleLoginClick}>
            Iniciar sesión
          </Button>
        </div>
      }
    />
  );
}
